module.exports = __webpack_public_path__ + "img/search_empty-3x.9554916d.png";